module.exports = __webpack_public_path__ + "static/policy_book1_1@2x-ba9b1f0d16d7da5e57f8ef894ddd3bae.png";